import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigurationSetAppData, refreshConfigurationSets } from '../store/appData';
import axios from 'axios'
import Backdrop from '../../../common/components/UI/Backdrop/Backdrop';
import Snackbar from '../../../common/components/UI/Snackbar/Snackbar';
import SideBar from '../../../common/components/UI/SideBar/SideBar';
import SuccesAnimated from '../../../common/components/UI/SuccessAnimated/SuccessAnimated'
import Form from '../components/Form';
import ConfigurationSetTable from '../components/ConfigurationSetTable';
import { currentHttpOptions, formatResponse } from '../../utils'
import { AdminSidePanelActionNames, PrivateEmployeeSource } from '../../Enums';
import ArchiveTableHeader from './ArchiveTableHeader';
import { usePrevious } from '../../../common-client2/src/hooks';
import { transformToArchiveModel } from './Archive.service';
import { PtoActionOnRejection } from '../../Enums/PtoActionOnRejection';
import './Archive.scss';

const Archive = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation('employmentBillboard');
    /** @type {AdminAppData.IAppData} */
    // @ts-ignore
    const adminAppData = useSelector((state) => state.adminAppData);
    const { isConfigurationSetAppDataLoaded, settingList, hyperfinds: hyperFindList, genericNotificationList, breRuleSetList, workRuleList, dataviews, payCodeList, segmentTagsList, awardingRulesList, timePeriodRatioOptions, breakRuleList } = adminAppData;
    const privateEmployeeSources = [
        {label: "Manager Home Location", value: PrivateEmployeeSource.ManagerHomeLocation},
        {label: "Hyperfind", value: PrivateEmployeeSource.Hyperfind},
    ];

    const ptoActionOnRejectionOptions = [
        { label: t("settings.ptoActionOnRejectionOptions.submitted"), value: PtoActionOnRejection.Submitted },
        { label: t("settings.ptoActionOnRejectionOptions.refused"), value: PtoActionOnRejection.Refused },
        { label: t("settings.ptoActionOnRejectionOptions.cancelled"), value: PtoActionOnRejection.Cancelled },
    ];

    useEffect(() => {
        if (!isConfigurationSetAppDataLoaded) {
            dispatch(fetchConfigurationSetAppData());
        }
    }, []);
    const [openForm, setOpenForm] = useState(false);
    const [showResponseDialog, setShowResponseDialog] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [displaySpinner, setDisplaySpinner] = useState(false);

    const [sideAction, setSideAction] = useState('');
    const [sortBySelected, setSortBySelected] = useState('name');
    const prevSortBySelected = usePrevious(sortBySelected);
    const [sortOrder, setSortOrder] = useState('Ascending');
    const [messageSnackbar, setMessageSnackbar] = useState('');
    const [typeSnackbar, setTypeSnackbar] = useState('success');
    const [originalSettingList] = useState(settingList.map(transformToArchiveModel(hyperFindList)).filter(x => x.isArchive));
    const [filteredsettingList, setFilteredsettingList] = useState(originalSettingList);
    const [settingSelected, setSettingSelected] = useState({});
    const actionTypeList = [
        { label: "To Cover", value: 0 },
        { label: "Shift Swap", value: 1 },
        { label: "Open Shift", value: 2 },
        { label: "Voluntary Time Off", value: 3 }
    ];
    const [responseStatus, setResponseStatus] = useState('');
    const [responseStatusText, setResponseStatusText] = useState('');

    const formTitle = sideAction === AdminSidePanelActionNames.Edit
        ? t('settings.adminSidePanelHeaderEdit')
        : t('settings.adminSidePanelHeader');
    
    const closeResponseDialog = () => {
        setTimeout(() => {
            setShowResponseDialog(false);
        }, 3000)
    }
    
    const handleSubmitForm = (form) => {
        setDisplaySpinner(true);
        const options = currentHttpOptions();

        return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/AddSetting', form, options).then(() => {
            dispatch(refreshConfigurationSets());

            setResponseStatus('success');
            setShowResponseDialog(true);
            setResponseStatusText(t('admin.successDuplicate'));
            setSettingSelected({});

            setOpenForm(false);
        }).catch(err => {
            handleSnackbar('error', err.response.data.Message, true);
        }).finally(e => {
            setDisplaySpinner(false);
            closeResponseDialog();
            handleSearchFilter()
        })
    }

    const handleSnackbar = (type, message, openState) => {
        setTypeSnackbar(type);
        setMessageSnackbar(message);
        setOpenSnackbar(openState);
    }

    const closeSnackbar = () => {
        setTimeout(() => {
            setOpenSnackbar(false)
        }, 5000)
    }

    const compareString = (sortProperty) => (a, b) => {
        var x = a[sortProperty].toString().toLowerCase();
        var y = b[sortProperty].toString().toLowerCase();
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    }

    const sortBy = async (sortIndex) => {
        var oldSortBy = sortBySelected;
        await setSortBySelected(sortIndex);
        
        const updatedSortOrder = sortOrder === 'Ascending' ? 'Descending' : 'Ascending';
        if (oldSortBy === sortIndex) {
            setFilteredsettingList(filteredsettingList.reverse());
            setSortOrder(updatedSortOrder);
        } else {
            setFilteredsettingList(filteredsettingList.sort(compareString));
            setSortOrder(updatedSortOrder);
        }
    }
    useEffect(() => {
        const updatedSortOrder = sortOrder === 'Ascending' ? 'Descending' : 'Ascending';
        var oldSortBy = prevSortBySelected;
        if (oldSortBy === sortBySelected) {
            setFilteredsettingList(filteredsettingList.reverse());
            setSortOrder(updatedSortOrder);
        } else {
            setFilteredsettingList(filteredsettingList.sort(compareString(sortBySelected)));
            setSortOrder(updatedSortOrder);
        }
    }, [sortBySelected])

    const cancelAction = () => {
        setOpenForm(false);
        setSideAction('');
        setSettingSelected({});
    }

    const rightPanelHandler = (sideAction, selectedItem) => {
        setSideAction(sideAction);
        if (sideAction === AdminSidePanelActionNames.Duplicate) {
            let otherProps = {};
            if (selectedItem.breRuleSetId !== null) {
                if (!breRuleSetList.find(x => x.id === selectedItem.breRuleSetId).isActive){
                    otherProps = { ...otherProps, breRuleSetId: null }
                }
            }
            if (selectedItem.awardingRuleId !== null) {
                if (!awardingRulesList.find(x => x.id === selectedItem.awardingRuleId).isActive){
                    otherProps = { ...otherProps, awardingRuleId: null }
                }
            }
            setSettingSelected({...selectedItem, ...otherProps});
        }
        else {
            setSettingSelected(selectedItem);
        }
        setOpenForm(true);
    }

    const handleSearchFilter = (event) => {
        const searchableFields = ['name', 'creationHyperfindName', 'managementHyperfindName', 'description']

        let filteredSettings = [];

        let searchFilter = event === undefined ? searchValue : (event.target.value === undefined) ? searchValue : event.target.value;

        if (searchFilter !== '') {
            for (const setting of originalSettingList) {
                for (const key in setting) {
                    if (searchableFields.includes(key)
                        && setting[key] !== null
                        && setting[key].toString().toLowerCase().includes(searchFilter.toLowerCase())) {
                        filteredSettings.push(setting)
                        break;
                    }
                }
            }
        } else {
            filteredSettings = originalSettingList;
        }
        setSearchValue(searchFilter);
        setFilteredsettingList(filteredSettings);
    }

    return (
        <>
            <hr className="admin-archive-divider" />
            <section className="admin-archive-content">
                <ArchiveTableHeader
                    handleSearchFilter={handleSearchFilter}
                    searchValue={searchValue}
                    t={t}
                />
                <ConfigurationSetTable
                    className="admin-archive-table"
                    sortBySelected={sortBySelected}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    filteredsettingList={filteredsettingList}
                    hyperfinds={hyperFindList}
                    rightPanelHandler={rightPanelHandler}
                    isArchive
                />
                <SideBar
                    className="admin-archive-sidebar"
                    handleDrawerClose={cancelAction}
                    open={openForm}
                    title={formTitle}
                    isCloseOnOutsideClick={false}
                >
                    <Form
                        action={sideAction}
                        actionTypeList={actionTypeList}
                        awardingRulesList={awardingRulesList}
                        breRuleSetList={breRuleSetList}
                        cancel={cancelAction}
                        dataviewList={formatResponse(dataviews, 'id', true)}
                        genericNotificationList={genericNotificationList}
                        handleSubmitForm={handleSubmitForm}
                        hyperFindList={hyperFindList}
                        payCodeList={payCodeList}
                        segmentTagsList={segmentTagsList}
                        settingList={originalSettingList}
                        settingSelected={settingSelected}
                        timePeriodRatioOptions={timePeriodRatioOptions}
                        workRuleList={workRuleList}
                        privateEmployeeSources={privateEmployeeSources}
                        ptoActionOnRejectionOptions={ptoActionOnRejectionOptions}
                        breakRuleList={breakRuleList}
                    />
                </SideBar>
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                {showResponseDialog ?
                    <SuccesAnimated
                        type={responseStatus}
                        open={showResponseDialog}
                        handleClose={() => setShowResponseDialog(false)}>
                        <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 16, color: '#3A3A3A' }}>{responseStatusText}</div>
                    </SuccesAnimated> : null}
            </section>
        </>);
}
export default Archive;
